import logo from './logo.png';

export const settings = {
    "title": "Genius Store",
    "apiUrl": "https://api.battaglia.geniuscloud.it/api",
    "ckdPath": "https://api.battaglia.geniuscloud.it/",
    "tinyKey": "uxd8thxx2a96p0tne20wyfcdx7zvpyprm38j5q5w9qqauy2p",
    "googleMapKey": "AIzaSyDwVSRwXezXuTLG8-VAe1KfNKo7zLPlYJQ",
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "supplier": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "sales_agent": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "supplier_payment_condition": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "customer_payment_condition": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "category": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "logo": logo,
    "data_print": {
        "name": 'Battaglia Arredamenti Srl',
        "address": 'Via Nazionale, 34 98047 Saponara Marittima (ME)',
        "phone": 'Tel: 090 332174',
        "fax": '',
        "email": 'Email: info@battagliarredamenti.com',
        "iva": 'P.IVA 03547700835',
        "cf": 'C.F. 03547700835',
        "website": 'www.battagliarredamenti.com',
    },
    "dati_pagamento": {
        "iban": "IBAN: IT02E0103082631000001303311",
        "bic": "",
        "banca": "	Monte dei Paschi di Siena",
        "intestatario": "Battaglia Arredamenti Srl",
    },
    "dati_fattura": {
        "statoPIVA": "IT",
        "PIVA": "03490440264",
        "PIVAcompleta": "IT03490440264",
        "regimeFiscale": "RF04",
        "numeroREA": "",
        "socioUnico": "SU",
        "statoLiquidazione": "LN",
        "ufficio": "",
        "indirizzo": "Corte delle Rose, 8",
        "cap": "31015",
        "comune": "Conegliano",
        "nazione": "IT",
        "provincia": "TV",
        "formatoTrasmissione": "FPR12",
        "codiceDestinatario": "A4707H7",
        "denominazione": "Prelude Advertising S.r.l.",
    },
    "iva_label": 'esclusa',
    "iva_esclusa": true,
    "sconti": true,
    "fatturazione": false,
    "usingCache": false
}